export default __webpack_public_path__ + "static/media/ic_cnote_24444.df22f304.svg";